
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13.879","height":"13.879"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.445 0H6.361a.434.434 0 00-.434.434v2.349H.434A.434.434 0 000 3.217v10.228a.434.434 0 00.434.434h7.081a.434.434 0 00.434-.434V11.1h5.5a.434.434 0 00.434-.434V.434A.434.434 0 0013.445 0zM7.081 13.011H.867V8.62h3.352l-1.392 1.393a.29.29 0 10.409.409l1.885-1.886a.29.29 0 000-.41L3.236 6.24a.29.29 0 00-.409.409l1.392 1.393H.867V3.65h6.214zm.867-2.779V3.217a.434.434 0 00-.434-.434h-.72V.867h6.217v4.394H9.658l1.393-1.393a.29.29 0 00-.409-.409L8.756 5.345a.29.29 0 000 .41l1.886 1.886a.29.29 0 00.409-.409L9.658 5.839h3.354v4.393z"}})])
          )
        }
      }
    